import { useState } from 'react'
import { AuthWithHeaders } from 'types'
import cx from 'classnames'

import client from 'api/client'
import { authFromResponse } from 'utils'
import { HOME_PATH } from 'paths'

// TODO: Remove Section.module.scss file completely once new Account page is implemented
import SectionStyles from 'components/Settings/Section.module.scss'
import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import Styles from './ImpersonateUser.module.scss'

import { Button } from 'components/Button'
import { UserService } from 'api/clients/UserService'
import { useAuth } from 'hooks/UseAuth'
import { useHeaders } from 'hooks/useHeaders'
import { useHistory } from 'react-router-dom'
import { Heading } from 'blaze-ui/Heading/Heading'

export const ImpersonateUser = () => {
  const auth = useAuth()
  const headers = useHeaders()
  const [userId, setUserId] = useState<number | null>(null)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [impersonating, setImpersonating] = useState<boolean>(false)
  const history = useHistory()

  if (!auth || !auth.almanac_admin) return null

  const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    setUserId(isNaN(parseInt(value)) ? null : parseInt(value, 10))
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') impersonateUser()
  }

  const impersonateUser = async () => {
    if (userId === null) {
      setErrorMessage('Please specify user ID')
      return
    }

    setImpersonating(true)

    const response = await client.impersonateUser(userId)

    if (response.type === 'success') {
      const adminAuth = auth
      const adminAuthorization = headers.authorization

      const impersonatedBy = { ...adminAuth } as AuthWithHeaders
      if (adminAuthorization) impersonatedBy.headers = { authorization: adminAuthorization }

      const userAuth = authFromResponse(response.data.data, response.headers)
      UserService.setAuthCookie({
        ...userAuth,
        headers: { authorization: response.headers.authorization, 'admin-authorization': adminAuthorization },
        impersonatedBy,
      })
      history.replace(HOME_PATH)
    } else {
      setImpersonating(false)
      setErrorMessage('Something went wrong, please try again')
    }
  }

  return (
    <>
      <div className={SettingsStyles.divider} />
      <div className={SectionStyles.sectionRow}>
        <div className={cx(SectionStyles.sectionFieldWrapper, SectionStyles.alignTop)}>
          <div className={SectionStyles.rowStyles}>
            <Heading level={5}>Impersonate User</Heading>
            <div className={cx(SectionStyles.sectionInput, Styles.actionForm)}>
              <input
                autoComplete={'off'}
                name="number"
                type="text"
                value={userId?.toString() || ''}
                onChange={handleUserIdChange}
                onKeyDown={handleKeyDown}
                placeholder="Enter a user id..."
                className={Styles.userIdInput}
              />
              <Button
                variant="secondary"
                onPress={() => impersonateUser()}
                data-test-id="reset-password"
                size="lg"
                isDisabled={impersonating}
              >
                Impersonate
              </Button>
            </div>
          </div>
          <div className={cx(SectionStyles.sectionInput, SectionStyles.newStyles, Styles.actionForm)}>
            <p className={SectionStyles.text}>
              <b>⚠️ Warning!</b> This functionality is intended for Blaze admins only. You should get written
              authorization from the impersonated user before using it.
            </p>
          </div>
        </div>
      </div>
      <p className={Styles.error}>{errorMessage}</p>
    </>
  )
}
